<div class="about-content">
  <div id="credential-div">
    @for (item of profile.xp.achievements; track item) {
      <div>
        <mat-card
          class="inner-card"
          style="display: flex; align-items: center; justify-content: center"
        >
          <a
            [href]="MICROSOFT_LEARN_URL + item.url"
            style="display: flex; align-items: center; justify-content: center"
          >
            <mat-card-content>
              <img
                mat-card-image
                style="height: 100px; width: 100px"
                [src]="MICROSOFT_LEARN_URL + item.imageUrl"
                [alt]="item.url"
              />
            </mat-card-content>
          </a>
          <mat-card-subtitle>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
              "
            >
              {{ item.title }}
            </div>
          </mat-card-subtitle>
          <mat-card-footer
            style="
              display: flex;
              align-items: baseline;
              justify-content: center;
            "
          >
            <h6>Powered by Microsoft Learn</h6>
          </mat-card-footer>
        </mat-card>
      </div>
    }

    @for (cred of credlyCreds; track cred) {
      <div>
        <mat-card class="inner-card">
          <mat-card-content>
            <div
              [attr.data-iframe-width]="cred.width"
              [attr.data-iframe-height]="cred.height"
              [attr.data-share-badge-id]="cred.badgeId"
              [attr.data-share-badge-host]="cred.host"
            ></div>
          </mat-card-content>
        </mat-card>
      </div>
    }

    <mat-card appearance="outlined" class="inner-card">
      <mat-card-content>
        <iframe
          title="skillshop credential"
          src="https://skillshop.credential.net/1869f2b9-3ca2-415d-a619-406abe69d7bc"
          height="285px"
          width="255px"
        >
        </iframe>
      </mat-card-content>
    </mat-card>

    <script
      src="assets/credentials/credly-embed.js"
      type="text/javascript"
      async
    ></script>
  </div>
</div>
